export default __webpack_public_path__ + "static/media/skeleton-empty-double-string2.b56252c6.svg";